
import axios from '../http'

const api = {
  abc:"/app/article/decryptMobile",
  faqApi:"/app/article/faqList"

}

const api1 = {
 
  abc(params) {
    return axios.post(api.abc, params)
  },
  faqApi() {
    return axios.get(api.faqApi)
  },
  
}
export default api1


// WEBPACK FOOTER //
// ./src/request/apis/test.js